{
  "hero": {
    "title": "Transform Education with AI",
    "subtitle": "Personalized learning experiences powered by artificial intelligence",
    "description": "Sigma08 adapts to each student's unique learning style, providing customized curricula and real-time progress tracking for optimal educational outcomes.",
    "cta": {
      "primary": "Start Free Trial",
      "secondary": "Watch Demo"
    }
  },
  "features": {
    "title": "Powerful Features for Modern Education",
    "subtitle": "Everything you need to enhance learning outcomes",
    "list": {
      "aiPersonalization": {
        "title": "AI-Powered Personalization",
        "description": "Adaptive learning paths that adjust to each student's pace and understanding"
      },
      "progressTracking": {
        "title": "Real-Time Progress Tracking",
        "description": "Monitor student advancement with detailed analytics and insights"
      },
      "curriculumManagement": {
        "title": "Smart Curriculum Management",
        "description": "Automated curriculum optimization based on learning outcomes"
      },
      "parentEngagement": {
        "title": "Parent Engagement Tools",
        "description": "Keep parents informed and involved in their child's education"
      },
      "assessmentTools": {
        "title": "Comprehensive Assessment",
        "description": "Multiple assessment types with instant feedback and grading"
      },
      "collaboration": {
        "title": "Collaborative Learning",
        "description": "Foster peer interaction and group learning activities"
      }
    }
  },
  "pricing": {
    "title": "Choose Your Plan",
    "subtitle": "Flexible pricing for schools and families",
    "monthly": "Monthly",
    "annual": "Annual",
    "savePercent": "Save {{percent}}%",
    "currency": "USD",
    "plans": {
      "starter": {
        "name": "Starter",
        "price": 29,
        "period": "per student/month",
        "description": "Perfect for individual families",
        "features": [
          "Up to 3 students",
          "Core curriculum access",
          "Basic progress tracking",
          "Email support",
          "Mobile app access"
        ],
        "cta": "Start Free Trial"
      },
      "professional": {
        "name": "Professional",
        "price": 49,
        "period": "per student/month",
        "description": "Ideal for small schools",
        "popular": true,
        "features": [
          "Up to 30 students",
          "Full curriculum library",
          "Advanced analytics",
          "Priority support",
          "Custom assessments",
          "Parent portal"
        ],
        "cta": "Start Free Trial"
      },
      "enterprise": {
        "name": "Enterprise",
        "price": "Custom",
        "period": "contact us",
        "description": "For large institutions",
        "features": [
          "Unlimited students",
          "Custom curriculum",
          "White-label options",
          "Dedicated support",
          "API access",
          "Training & onboarding"
        ],
        "cta": "Contact Sales"
      }
    }
  },
  "testimonials": {
    "title": "What Educators Are Saying",
    "subtitle": "Join thousands of satisfied teachers and parents",
    "list": [
      {
        "quote": "Sigma08 has revolutionized how we approach personalized learning in our school.",
        "author": "Sarah Johnson",
        "role": "Principal",
        "organization": "Westfield Academy"
      },
      {
        "quote": "The AI recommendations have helped my daughter improve her math scores by 40%.",
        "author": "Michael Chen",
        "role": "Parent",
        "organization": "Parent of 8th grader"
      },
      {
        "quote": "Finally, a platform that adapts to each student's unique learning style.",
        "author": "Emily Rodriguez",
        "role": "Teacher",
        "organization": "Lincoln Middle School"
      }
    ]
  },
  "cta": {
    "title": "Ready to Transform Your Education?",
    "subtitle": "Join thousands of schools and families using Sigma08",
    "button": "Start Your Free Trial",
    "trial": "14-day free trial • No credit card required • Cancel anytime"
  },
  "stats": {
    "students": {
      "value": "50,000+",
      "label": "Active Students"
    },
    "schools": {
      "value": "500+",
      "label": "Partner Schools"
    },
    "improvement": {
      "value": "35%",
      "label": "Average Grade Improvement"
    },
    "satisfaction": {
      "value": "98%",
      "label": "Satisfaction Rate"
    }
  }
}
